/**
 * @desc 财务收支应用表更新
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.FinanceAccountRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/financeAccount/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
